<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑运费配置' : '添加运费配置'"></el-page-header>
		<el-form ref="form" label-position="right" :model="formData" label-width="auto" show-message inline-message
				 status-icon>
			<el-form-item label="配送方式名称">
				<el-input v-model="formData.name" placeholder="请输入配送方式名称"></el-input>
			</el-form-item>
			<el-form-item label="排序">
				<el-input v-model="formData.orders" placeholder="请输入排序"></el-input>
			</el-form-item>
			<el-form-item label="计费方式">
				<el-radio v-model="formData.method" :label="'1'">按件计费</el-radio>
<!--				<el-radio v-model="formData.method" :label="'2'">按重量计算</el-radio>-->
			</el-form-item>
			<div>
				<el-form-item label="配送区域" class="delivery">
					<span>运送到</span>
					<div class="delivery-top" v-if="formData.method == 2">
						<span>首重 (Kg)</span>
						<span>运费(元)</span>
						<span>续重(Kg)</span>
						<span>续费(元)</span>
						<span>邮费满额包邮(元)</span>
						<span>管理</span>
					</div>
					<div class="delivery-top" v-else>
						<span>首件 (个)</span>
						<span>运费(元)</span>
						<span>续件 (个)</span>
						<span>续费(元)</span>
						<!--						<span>邮费满额包邮(元)</span>-->
						<span style="display: inline-block;width: 200px;">管理</span>
					</div>
					<div class="area-box" v-for="(attr,index) in templateList">
						<span class="area-title">{{attr.region_name}}</span>
						<div class="area-list-box">
							<el-input v-model="attr.first" class="area-list"></el-input>
							<el-input v-model="attr.first_fee" class="area-list"></el-input>
							<el-input v-model="attr.additional" class="area-list"></el-input>
							<el-input v-model="attr.additional_fee" class="area-list"></el-input>
							<!--							<el-input v-model="attr.freeFees" class="area-list"></el-input>-->
							<div style="display: inline-block;width: 200px;text-align: center">
								<el-button type="" @click="editCity(attr,'配送区域',index,1)">编辑</el-button>
								<el-button type="danger " @click="delCity(attr,'配送区域',index,1)">删除</el-button>
							</div>
						</div>
					</div>
					<!-- 上次选中的ID已经赋值给了area_id 这次进来置空 不要有上次的ID。这次进来存的是areaItemp[2]的数据-->
					<div class="areaBtn" @click="addCity(1)">新增配送区域</div>
				</el-form-item>

			</div>
			<el-form-item>
				<el-button type="primary" @click="handleSubmit">保存</el-button>
			</el-form-item>
		</el-form>
		<city ref="city" @selectCity="selectCity" :type="type"></city>
	</div>
</template>
<script>
	import city from '@/components/checkCity/city';

	export default {
		data() {
			return {
				addressModal: false,
				type: 1,
				isTemplate: false,
				columns: [
					{
						title: '可配送区域',
						key: 'region_name',
						minWidth: 100,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'text',
									readonly: true,
									size: 'small',
									value: that.templateList[params.index].region_name
								}
							})
						}
					},
					{
						title: '首件',
						key: 'first',
						minWidth: 70,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'number',
									size: 'small',
									value: that.templateList[params.index].first // 此处如何让数据双向绑定
								},
								on: {
									'on-change': (event) => {
										that.templateList[params.index].first = event.target.value;
									}
								}
							})
						}
					},
					{
						title: '运费（元）',
						key: 'first_fee',
						minWidth: 70,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'number',
									size: 'small',
									value: that.templateList[params.index].first_fee // 此处如何让数据双向绑定
								},
								on: {
									'on-change': (event) => {
										that.templateList[params.index].first_fee = event.target.value;
									}
								}
							})
						}
					},
					{
						title: '续件',
						key: 'additional',
						minWidth: 70,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'number',
									size: 'small',
									value: that.templateList[params.index].additional // 此处如何让数据双向绑定
								},
								on: {
									'on-change': (event) => {
										that.templateList[params.index].additional = event.target.value;
									}
								}
							})
						}
					},
					{
						title: '续费（元）',
						key: 'additional_fee',
						minWidth: 70,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'number',
									size: 'small',
									value: that.templateList[params.index].additional_fee // 此处如何让数据双向绑定
								},
								on: {
									'on-change': (event) => {
										that.templateList[params.index].additional_fee = event.target.value;
									}
								}
							})
						}
					},
					{
						title: '操作',
						slot: 'action',
						minWidth: 70
					}
				],
				columns2: [
					{
						title: '选择地区',
						key: 'placeName',
						minWidth: 250,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'text',
									readonly: true,
									size: 'small',
									value: that.appointList[params.index].placeName
								}
							})
						}
					},
					{
						title: '包邮件数',
						key: 'a_num',
						minWidth: 100,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'number',
									size: 'small',
									value: that.appointList[params.index].a_num // 此处如何让数据双向绑定
								},
								on: {
									'on-change': (event) => {
										that.appointList[params.index].a_num = event.target.value;
									}
								}
							})
						}
					},
					{
						title: '包邮金额（元）',
						key: 'a_price',
						minWidth: 100,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'number',
									size: 'small',
									value: that.appointList[params.index].a_price // 此处如何让数据双向绑定
								},
								on: {
									'on-change': (event) => {
										that.appointList[params.index].a_price = event.target.value;
									}
								}
							})
						}
					},
					{
						title: '操作',
						slot: 'action',
						minWidth: 100
					}
				],
				columns3: [
					{
						title: '选择地区',
						key: 'placeName',
						minWidth: 250,
						render: (h, params) => {
							return h('Input', {
								props: {
									type: 'text',
									readonly: true,
									size: 'small',
									value: that.noDeliveryList[params.index].placeName
								}
							})
						}
					},
					{
						title: '操作',
						slot: 'action',
						minWidth: 100
					}
				],
				templateList: [
				],
				appointList: [],
				noDeliveryList: [],
				formData: {
					method: '1',
					name: '',
					orders: ''
				},
				id: this.$route.query.id ? this.$route.query.id : 0,
				indeterminate: true,
				checkAll: false,
				checkAllGroup: [],
				activeCity: -1,
				provinceAllGroup: [],
				index: -1,
				displayData: '',
				currentProvince: '',
				selectArr:[], // 传递选中的城市
				noShippingArr:[], // 不包邮选择的城市数据
				yesShippingArr:[], // 包邮选择的城市数据
				noDeliveryArr:[], // 不送达选择的城市数据
				isLoad: false,
			}
		},
		components: {
			city
		},
		created() {
			if (this.id) {
				this.editFrom(this.id)
			}
		},
		methods: {
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			editFrom (id) {
				var that = this
				this.id = id;
				this.axios.post('/supplier/delivery/detail', {
					id: id
				})
						.then(res => {
							var detail = res.data.detail
							this.formData = {
								method: detail.method.toString(),
								orders: detail.orders,
								name: detail.name
							}

							this.templateList = detail.rule
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
			},
			selectCity: function (data, type) {
				const { custom: { scene, num } } = data
				switch (type) {
					case 1:
						if (scene == 'add') {
							this.templateList.push({
								region: data.selectedCityIds,
								region_name: data.selectedText,
								first: 1,
								first_fee: 0,
								additional: 1,
								additional_fee: 0
							});
						} else {
							this.templateList[num].region = data.selectedCityIds
							this.templateList[num].region_name = data.selectedText
						}
						break;
				}
			},
			// 单独添加配送区域
			addCity (type) {
				this.$refs.city.addressModal = true;
				this.type = type;
				var scene = 'add'
				var num  = 0;
				this.$refs.city.getCityList({ scene, num }, [], this.getExcludedCityIds())
			},
			editCity(row, tit, num, type) {
				this.$refs.city.addressModal = true;
				this.type = type;
				var scene = 'edit'
				this.$refs.city.getCityList({ scene, num }, row.region, this.getExcludedCityIds())
			},
			getCityIds(region) {
				const cityIds = []
				region.forEach(provice => {
					provice.city.forEach(city => {
						cityIds.push(city.id)
					})
				})

				return cityIds;
			},
			// 排除的城市id集(已存在的城市id集)
			getExcludedCityIds () {
				const excludedCityIds = []
				this.templateList.forEach(item => {
					item.region.forEach(cityId => {
						excludedCityIds.push(cityId)
					})
				})
				return excludedCityIds
			},
			changeRadio () {
				this.headerType();
			},
			headerType () {
				let that = this;
				if (this.formData.method === 2) {
					that.columns[1].title = '首重量(KG)'
					that.columns[3].title = '续重量(KG)'
					that.columns2[1].title = '包邮重量(KG)'
				} else {
					that.columns[1].title = '首件'
					that.columns[3].title = '续件'
					that.columns2[1].title = '包邮件数'
				}
			},
			// 提交
			handleSubmit: function () {
				let that = this;
				if (!that.formData.name.trim().length) {
					return that.$Message.error('请填写模板名称');
				}
				for (let i = 0; i < that.templateList.length; i++) {
					if (that.templateList[i].first <= 0) {
						return that.$Message.error('首件/重量/体积应大于0');
					}
					if (that.templateList[i].first_fee < 0) {
						return that.$Message.error('运费应大于等于0');
					}
					if (that.templateList[i].additional <= 0) {
						return that.$Message.error('续件/重量/体积应大于0');
					}
					if (that.templateList[i].additional_fee < 0) {
						return that.$Message.error('续费应大于等于0');
					}
				}
				let data = {
					rules: that.templateList,
					orders: that.formData.orders,
					method: that.formData.method,
					name: that.formData.name,
				};
				console.log(this.id)
				if (this.id == 0) {
					this.axios.post('/supplier/delivery/add', {
						id: this.id,
						form: data
					}).then(res => {
						this.isTemplate = false;
						that.addressModal = false;
						that.cancel()
						// 通知父端组件提交完成了
						that.goBack()
					})
							.catch(() => {

								// this.isLoad = !this.isLoad
							})

				} else {
					this.axios.post('/supplier/delivery/edit', {
						id: this.id,
						form: data
					})
							.then(res => {
								that.isTemplate = false;
								that.addressModal = false;
								that.cancel()
								// 通知父端组件提交完成了
								that.goBack()
							})
							.catch(() => {
								// this.isLoad = !this.isLoad
							})
				}
			},
			// 删除
			delCity (row, tit, num, type) {
				this.templateList.splice(num, 1);
			},
			// 关闭
			cancel () {
				this.formData = {
					method: 1,
					sort: 0,
					name: '',
				};
				this.addressModal = false;
				this.templateList = [
				];
			},

			address () {
				this.addressModal = true
			},
			enter (index) {
				this.activeCity = index;
			},
			leave () {
				this.activeCity = null;
			}
		}
	}
</script>
<style scoped="scoped">
	.delivery {
		position: relative;
	}

	.delivery-top {
		position: absolute;
		right: 0;
		top: 0;
		height: 40px;
	}

	.delivery-top span {
		display: inline-block;
		min-width: 90px;
		line-height: 40px;
		margin-right: 10px;
		text-align: center;
	}

	.area-box {
		position: relative;
		margin-bottom: 20px;
	}

	.area-box .area-title {
		display: inline-block;
		width: 860px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		padding-left: 10px;
	}

	.areaNo-title {
		display: inline-block;
		width: 100%;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		padding-left: 10px;
	}

	.area-box .area-list-box {
		position: absolute;
		right: 0;
		top: 0;
	}

	.area-box .area-list {
		width: 90px;
		margin-right: 17px;
	}

	.areaBtn {
		width: 120px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #E5E5E5;
		text-align: center;
		cursor: pointer;
	}

	.cityList {
		min-width: 180px;
		height: 30px;
		line-height: 30px;
	}
</style>
